import React from "react";
import { FaCar, FaRoad, FaCogs, FaGasPump, FaPalette, FaCheckCircle, FaTimesCircle } from "react-icons/fa";

function AutomobileDetails({ product }) {
    if (!product) return <p className="productspec-error">Məhsul detalları yüklənmir...</p>;

    const getStatus = (val, yes = "Bəli", no = "Xeyr") =>
        val === true ? yes : val === false ? no : "Bilinmir";

    const specs = [
        { label: "Şəhər", value: product.city, icon: <FaCar /> },
        { label: "Marka", value: product.brand, icon: <FaCar /> },
        { label: "Model", value: product.model },
        { label: "İstehsal ili", value: product.year },
        { label: "Yanacaq növü", value: product.fuelType, icon: <FaGasPump /> },
        { label: "Yürüş", value: product.mileage ? `${product.mileage} km` : null, icon: <FaRoad /> },
        { label: "Ötürücü", value: product.transmission, icon: <FaCogs /> },
        { label: "Mühərrik həcmi", value: product.engineVolume },
        { label: "Mühərrik gücü", value: product.enginePower },
        { label: "Ötürücü tipi", value: product.driveType },
        { label: "Ban tipi", value: product.bodyType },
        { label: "Rəng", value: product.color, icon: <FaPalette /> },
        { label: "Oturacaq sayı", value: product.seatCount },
        { label: "Qapı sayı", value: product.doorCount },
        { label: "Yeni?", value: getStatus(product.isNew), status: product.isNew },
        { label: "Sahiblərin sayı", value: product.ownerCount },
        { label: "Texniki baxış", value: getStatus(product.hasTechnicalInspection, "Keçib", "Keçməyib"), status: product.hasTechnicalInspection },
        { label: "Sığorta", value: getStatus(product.hasInsurance, "Var", "Yoxdur"), status: product.hasInsurance },
        { label: "Qəzalı olub?", value: getStatus(product.isAccidented), status: product.isAccidented === false },
        { label: "VIN", value: product.vin },
        { label: "Bazar tipi", value: product.marketCountry }
    ];

    return (
        <div className="productspec-container">
            <div className="productspec-header">
                <FaCar className="productspec-header__icon" />
                <h3 className="productspec-header__title">Avtomobil Məlumatları</h3>
            </div>

            <div className="productspec-grid">
                {specs.map((spec, index) => {
                    if (!spec.value || spec.value === "Bilinmir") return null;
                    
                    return (
                        <div key={index} className="productspec-item">
                            {spec.icon && <span className="productspec-item__icon">{spec.icon}</span>}
                            <div className="productspec-item__content">
                                <span className="productspec-item__label">{spec.label}</span>
                                <span className={`productspec-item__value ${spec.status !== undefined ? (spec.status ? 'productspec-item__value--success' : 'productspec-item__value--danger') : ''}`}>
                                    {spec.status !== undefined && (
                                        spec.status ? <FaCheckCircle className="productspec-status-icon productspec-status-icon--success" /> : <FaTimesCircle className="productspec-status-icon productspec-status-icon--danger" />
                                    )}
                                    {spec.value}
                                </span>
                            </div>
                        </div>
                    );
                })}
            </div>

            {product.description && (
                <div className="productspec-description">
                    <h4 className="productspec-description__title">Əlavə Təsvir</h4>
                    <p className="productspec-description__text">{product.description}</p>
                </div>
            )}
        </div>
    );
}

export default AutomobileDetails;